import * as Msal from 'msal';
import { LogLevel } from 'msal';

export const msalConfig = {
  auth: {
      clientId: "54cf0c71-dad3-4111-8700-f1b2fdf37f51",
      authority: "https://login.microsoftonline.com/95806b5c-5613-4e1c-94b4-8eb408affe5c",
      redirectUri: `${process.env.REACT_APP_AUTH_URI}`
      //redirectUri: "https://apps.tgs.com.ar/etgs",
      //redirectUri: "https://apps-qa.tgs.com.ar/etgs",
      //redirectUri: "https://apps-cont.tgs.com.ar/etgs",
      //redirectUri: "http://localhost:3000/etgs",
  },
  scopes:['openid', 'email', 'profile','user.read'],
  cache: {
      cacheLocation: "sessionStorage", 
      storeAuthStateInCookie: false, 
  },
  system: {	
      loggerOptions: {	
          loggerCallback: (level, message, containsPii) => {	
              if (containsPii) {		
                  return;		
              }		
              switch (level) {
                  case LogLevel.Error:
                      console.error(message);
                      return;
                  case LogLevel.Info:
                      console.info(message);
                      return;
                  case LogLevel.Verbose:
                      console.debug(message);
                      return;
                  case LogLevel.Warning:
                      console.warn(message);
                      return;
                  default:
                      return;
              }	
          }	
      }	
  }
};


export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
};

export const msalInstance = new Msal.UserAgentApplication(msalConfig);
